module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/bryce_canyon_national_park-82485ae218d5e4eca4d692e64280ec91.jpg";